import React from 'react';
  
const ButtonList = (props) => { 
       return (
        <>
            <ul className='not-navigation' onClick= {props.Click} >
            <li><a className='click' data-position = 'incorrect' href='#how-it-works-area'>Table of incorrectly cited</a></li>
              <li><a className='click' data-position = 'textReferences' href='#how-it-works-area'>List of References in text</a></li>
              <li><a className='click' data-position = 'authors' href='#how-it-works-area'>List of Authors Cited in text.</a></li>
              <li><a className='click' data-position = 'html' href='#how-it-works-area'>Your Document</a></li>
            </ul>
        </> 
 
       ); 
};
 
export default ButtonList; 